import React, { useState } from 'react';
import reactUpdate from 'react-addons-update';
import Switch from 'react-bootstrap-switch';
import _ from 'underscore';
import { Link } from 'react-router-dom'

import Modal from '../../../../common/components/Modal';

import EmbedStringGenerator from '../../../../embed/lib/EmbedStringGenerator';
import RestrictedComponent from '../../../../lib/components/form/RestrictedComponent';
import schema from '../../../../routes/permissions/schema';

const PersistentTab = props => {
    const [edited, setEdited] = useState(false)
    const [edits, setEdits] = useState({})
    const [modal, setModal] = useState(false)
    const [renderMode, setRenderMode] = useState('script')

    const transferState =  () => {
        if (!edited) {
            var { encoder } = props;
            setEdited(true)
            setEdits(_.pick(encoder, 'live245URI'))
        }
    }

    const handleChange = (name, value, toggle) => {
        transferState();

        if (name == 'live247URI') value = toggle;

        var updates = {};
        updates[name] = {$set: value};
        setEdits(reactUpdate(edits, updates))
    }

    const handleSave = () => {
        var { encoder } = props;

        var newVal = (edits.live247URI) ? true : false;

        props.actions.edit({
            encoderID: encoder.encoderID,
            persistant: newVal,
            persistent: newVal
        }, function (err, resp) {
            if (err) {
                props.emitSnack({
                    type: 'error',
                    message: err.message
                });
            } else {
                props.emitSnack({
                    type: 'success',
                    message: 'Encoder Updated'
                });
            }
        });

        revert();
    }

    const revert = () => {
        setEdited(false)
        setEdits({})
    }

    const toggleModal = () => {
        setModal(!modal)
    }

    const toggleEmbedType = () => {
        setRenderMode((renderMode == 'script') ? 'iframe' : 'script')
    }

    var { encoder } = props;

    var persistentEnabled = (edited) ? edits.live247URI : !!encoder.live247URI;

    const renderModal = () => {
        if (modal) {
            return (<Modal
                saveAction={<RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_ENCODERS.UPDATE}>
                    <button className="btn btn-success" onClick={handleSave}>
                        <i className="fa fa-save"/> Save
                    </button>
                </RestrictedComponent>}
                cancelModal={toggleModal}>
                <Modal.Header>Make stream Persistent?</Modal.Header>
                <Modal.Body>
                    <div className="alert alert-danger">
                        <strong>Notice:</strong>
                        <p>Billing Charges Will Apply.</p>
                        <p><strong><Link to="/help">Please reference the documentation here ...</Link></strong></p>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>);
        }
    }

    const renderEmbedString = () => {
        var { encoder, credentials } = props;
        if (!encoder.live247URI) return;

        // Flatten nested objects so the query-string lib retains the structure
        // https://www.npmjs.com/package/query-string#nesting
        var data = {
            player: {
                autoStart: true,
                trackAnalytics: true
            },
            model: {
                key: 'encoder',
                encoderID: 'uid',
                streamName: 'name',
                live247URI: 'uri'
            },
            encoder: _.pick(props.encoder,
                'encoderID',
                'streamName',
                'live247URI'
            )
        };

        if (renderMode == 'script') {
            // @NOTE `selector` only pertains to the Script embed
            data.selector = 'persistent-stream-' + encoder.encoderID;
        }

        return (<div className="panel panel-default" style={{margin: '2em 0'}}>
            <div className="clearfix panel-heading">
                <div className="col-md-8">
                    <h4>{(renderMode == 'script') ? 'Script Tag' : 'iFrame'}</h4>
                </div>
                <div className="col-md-4 text-right">
                    <Switch
                        onText="Script"
                        offText="iFrame"
                        onChange={toggleEmbedType}
                        value={renderMode == 'script' ? true : false}
                        animate={false}/>
                </div>
            </div>
            <div className="panel-body">
                <EmbedStringGenerator
                    persistentStreamData={data}
                    clientID={credentials.clientID}
                    domain="persistent"
                    renderMode={renderMode}/>
            </div>
        </div>);
    }

    return (<div className="col-xs-12 tab-content">
        <div className="col-md-12 form-elements">
            <label style={{paddingRight: '1em'}}>Live 24/7 Streaming</label>
            <Switch
                onText="Enabled"
                offText="Disabled"
                onChange={handleChange.bind(null, 'live247URI')}
                value={persistentEnabled}
                animate={false}/>

            {renderEmbedString()}

        </div>
        <div className="col-md-12 form-actions">
            <button className="btn btn-default" disabled={!edited} onClick={revert}>
                <i className="fa fa-undo"/> Reset
            </button>
            <button className="btn btn-success" disabled={!edited} onClick={toggleModal}>
                <i className="fa fa-save"/> Save
            </button>
        </div>
        {renderModal()}
    </div>);
}

export default PersistentTab;
